import { DateHelpers } from "../../helpers/date-helpers";
import { ObjectHelpers } from "../../helpers/object-helpers";
import { IChartData } from "./chart-data.interface";

export class TIChartPointModel implements IChartData {
    public open = 0;
    public low = 0;
    public high = 0;
    public close = 0;
    public volume = 0;
    public volumeAvg = 0;
    public timestamp = 0;
    public xValue = 0;
    public startTimeT = 0;
    public endTimeT = 0;
    public goLevel: number | null = null;
    public start = new Date();
    public startMarketTimeZone = new Date();
    public endMarketTimeZone = new Date();
    public end = new Date();
    public symbol = '';
    public color = '';
    public isPreMarket = false;
    public isPostMarket = false;
    
    constructor(chartData?: any) {
        if (chartData) {
            ObjectHelpers.setProperties(chartData, this, true);
    
            if (this.start) {
                this.timestamp = DateHelpers.getTimeStampWithCurrentTimezone(this.start);
            }
        }
    }

    public isUpBar(): boolean {
        return this.close >= this.open;
    }
}